import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import { CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG } from "assets";
import { logoFullWhite, logoIconWhite, logoBill } from "assets/images/logo/";
import ReactToPrint from "react-to-print";
import {
  doiTuongOptions,
  gioiTinhOptions,
  doiTuongKCB,
} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import { payService } from "api";
import { columns, getTodayString } from "./ModalPrint.config";
import { useAppSelector } from "redux/hooks";
import moment from "moment";
import "./ModalPrint.scss";
import { FORMAT_TIME } from "types/enums";
import { ReactComponent as PhoneSVG } from "assets/icons/phone-svg.svg";
import { ReactComponent as MailSVG } from "assets/icons/mail-svg.svg";
import { ReactComponent as InternetSVG } from "assets/icons/internet-svg.svg";
import {
  birthday2Age,
  formatToCurrencyType,
  getDateStringLocale,
  getDateStringLocaleDetail,
} from "helper/common";

const { Text } = Typography;

const ModalPrint = (props) => {
  const { isShowModal, handleOk, handleCancel, listId } = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  // const [data, setData] = useState([]);
  // const idLanKham = useAppSelector((state) => state.reduxCommon.id);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const idBh = useAppSelector((state) => state.common.idReceiptPrint);
  // console.log('listID', listId);

  useEffect(() => {
    getData();
  }, [isShowModal, listId]);

  const getData = async () => {
    const body = {
      list_id: listId,
    };
    try {
      let response = await payService.getDataPrintPrepay(body).then((res) => {
        // console.log('data in tạm ứng', res);
        setThongTinIn(res.data.data);
        // const newData = res.data.data.chiDinhDtoList.map((item) => ({
        //   noiDung: item.noiDung,
        //   donVi: item.donVi,
        //   soLuong: item.soLuong,
        //   donGiaBV: item.donGiaBenhVien,
        //   donGiaBH: item.donGiaBaoHiem,
        //   thanhTien: item.thanhTien,
        //   bhChiTra: item.baoHiemChiTra,
        //   bnCungChiTra: item.benhNhanCungChiTra,
        //   bnTra: item.benhNhanTra,
        // }));
        // setData(newData);
      });
    } catch (err) {}
  };

  const calculateAge = (birthDate) => {
    let currentDate: any = new Date();
    let birthDateParts: any = birthDate.split("/"); // Chia chuỗi thành mảng [ngày, tháng, năm]

    // Chuyển đổi ngày sinh thành một đối tượng Date
    let birthDateObject: any = new Date(
      birthDateParts[2],
      birthDateParts[1] - 1,
      birthDateParts[0]
    ); // Lưu ý: tháng trong đối tượng Date từ 0 đến 11

    let ageInMilliseconds = currentDate - birthDateObject;
    let ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // Sử dụng 365.25 để xem xét năm nhuận
    let ageInMonths = ageInYears * 12;

    if (ageInYears < 1) {
      return Math.floor(ageInMonths) + " tháng";
    } else {
      return Math.floor(ageInYears) + " tuổi";
    }
  };

  const onPrint = async () => {
    window.print();
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    // <Row className='exam-reg-bill'>
    <Modal
      wrapClassName="modal-custom-print-prepay"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      width={1000}
    >
      <div className="print-tam-ung">
        <div ref={printRef} className="content">
          <Row style={{ paddingRight: "50px" }}>
            <Col span={15}>
              <Row
                style={{
                  justifyContent: "space-between",
                  padding: "0px 10px 0 20px",
                }}
              >
                <Col>
                  <Row justify={"center"}>
                    <Typography.Text strong style={{ fontSize: "12px" }}>
                      BỘ Y TẾ
                    </Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text strong style={{ fontSize: "12px" }}>
                      BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                    </Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Typography.Text strong style={{ fontSize: "12px" }}>
                      Số: {thongTinIn?.so}
                    </Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text strong style={{ fontSize: "12px" }}>
                      Ngày ứng:{" "}
                      {thongTinIn?.ngayUng
                        ? moment(thongTinIn?.ngayUng).format(
                            FORMAT_TIME.dayFull
                          )
                        : ""}
                    </Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text strong style={{ fontSize: "12px" }}>
                      Ngày in: {moment().format(FORMAT_TIME.dayFull)}
                    </Typography.Text>
                  </Row>
                </Col>
              </Row>
              {/* <Row
            align={"middle"}
            justify={"space-between"}
            style={{ padding: "10px 24px 0 24px" }}
          >
            <Col span={22}>
              <Row>
                <Typography.Text strong style={{ fontSize: "20px" }}>
                  Bệnh viện chuyên khoa mắt Alina
                </Typography.Text>
              </Row>
              <Row justify={"space-between"}>
                <Col>
                  <Row style={{ gap: "8px" }} align={"middle"}>
                    <PhoneSVG />
                    <Typography.Text>0866224883</Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{ gap: "8px" }} align={"middle"}>
                    <LocationSVG />
                    <Typography.Text>
                      Xuân Giang, Văn Giang, Hưng Yên
                    </Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{ gap: "8px" }} align={"middle"}>
                    <MailSVG />
                    <Typography.Text>contact@alinavn.com</Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{ gap: "8px" }} align={"middle"}>
                    <InternetSVG />
                    <Typography.Text>alinavn.com</Typography.Text>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={2}>
              <Row justify={"end"}>
                <img
                  src={logoBill}
                  style={{
                    height: "32px",
                  }}
                />
              </Row>
            </Col>
          </Row> */}
              <Row
                style={{
                  paddingLeft: "20px",
                  paddingRight: "10px",
                }}
              >
                <Row justify={"center"}>
                  <Typography.Title
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                    }}
                  >
                    PHIẾU TẠM ỨNG
                  </Typography.Title>
                </Row>
                <Row>
                  <Col span={12}>
                    <Row>
                      <Descriptions
                        column={{
                          xs: 1,
                          sm: 1,
                          md: 1,
                          xl: 1,
                          lg: 1,
                          xxl: 1,
                        }}
                        size="small"
                      >
                        <Descriptions.Item
                          label="Họ và tên"
                          labelStyle={{ width: "94px", color: "#000000" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {thongTinIn?.hoTen}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="Ngày sinh"
                          labelStyle={{ width: "94px", color: "#000000" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {thongTinIn?.ngaySinh}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="Tuổi"
                          labelStyle={{ width: "94px", color: "#000000" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {thongTinIn?.ngaySinh
                            ? birthday2Age(thongTinIn.ngaySinh, true)
                            : null}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="Giới tính"
                          labelStyle={{ width: "94px", color: "#000000" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {gioiTinhOptions.find(
                            (it) => it.value === thongTinIn?.gioiTinh
                          )?.label || ""}
                        </Descriptions.Item>
                        {/* <Descriptions.Item
                          label="Điện thoại"
                          labelStyle={{ width: "94px" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {thongTinIn?.dienThoai}
                        </Descriptions.Item> */}
                        {/* <Descriptions.Item
                          label="Địa chỉ"
                          labelStyle={{ width: "94px" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {thongTinIn?.diaChi}
                        </Descriptions.Item> */}
                        {/* <Descriptions.Item
                          label="Số thẻ BHYT"
                          labelStyle={{ width: "94px" }}
                          contentStyle={{
                            fontWeight: "600",
                          }}
                        >
                          {thongTinIn?.soTheBaoHiemYTe}
                        </Descriptions.Item> */}
                      </Descriptions>
                    </Row>
                  </Col>
                  <Col span={12}>
                    <Descriptions
                      column={{
                        xs: 1,
                        sm: 1,
                        md: 1,
                        xl: 1,
                        lg: 1,
                        xxl: 1,
                      }}
                    >
                      <Descriptions.Item
                        label="Mã phiếu khám"
                        labelStyle={{ width: "124px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinIn?.maPhieuKham}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Mã bệnh nhân"
                        labelStyle={{ width: "124px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinIn?.maBenhNhan}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Đối tượng KCB"
                        labelStyle={{ width: "110px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {doiTuongKCB.find(
                          (it) => it.value === thongTinIn?.doiTuongKhamChuaBenh
                        )?.label || ""}
                      </Descriptions.Item>
                    </Descriptions>
                  </Col>
                </Row>
                {/* <Row style={{paddingLeft: "3px"}}>
                  <Space>
                    <Text style={{color: "#999999", fontSize: "15px"}}>Địa chỉ:</Text>
                    <Typography.Text strong style={{fontSize: "15px"}}>
                      {thongTinIn?.diaChi}
                    </Typography.Text>
                  </Space>
                </Row> */}
                <Row>
                  <Col>
                    <Descriptions
                      column={{
                        xs: 1,
                        sm: 1,
                        md: 1,
                        xl: 1,
                        lg: 1,
                        xxl: 1,
                      }}
                    >
                      <Descriptions.Item
                        label="Địa chỉ"
                        labelStyle={{ width: "94px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinIn?.diaChi}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Lần thu tiền thứ"
                        labelStyle={{ width: "124px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinIn?.lanThuTienThu}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Số tiền thu"
                        labelStyle={{ width: "124px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {formatToCurrencyType(thongTinIn?.soTienThu)}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Số tiền bằng chữ"
                        labelStyle={{ width: "124px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {capitalizeFirstLetter(thongTinIn?.soTienBangChu)}
                      </Descriptions.Item>
                    </Descriptions>
                  </Col>
                </Row>
                <Row style={{ marginTop: "0px" }}>
                  <Row justify={"end"}>
                    <Typography.Text
                      className="date-sign"
                      style={{ marginRight: "15px" }}
                    >
                      {getDateStringLocale(thongTinIn?.ngayUng)}
                    </Typography.Text>
                  </Row>
                  <Row justify={"space-between"}>
                    <Col>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            Người nộp tiền
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                    </Col>
                    <Col>
                      <Space direction="vertical">
                        <Row>
                          <Row justify={"center"}>
                            <Typography.Text strong>
                              Tên thu ngân
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text type="secondary">
                              (Ký và ghi rõ họ tên)
                            </Typography.Text>
                          </Row>
                        </Row>
                        <Row justify={"center"} style={{ marginTop: "20px" }}>
                          <Typography.Text strong>
                            {thongTinIn?.tenThuNgan
                              ? thongTinIn?.tenThuNgan
                              : localStorage.getItem("fullName")}
                          </Typography.Text>
                        </Row>
                      </Space>
                    </Col>
                  </Row>
                  <Row></Row>
                </Row>
              </Row>
            </Col>
            <Col
              span={9}
              style={{ paddingLeft: "30px", borderLeft: "3px solid #999999" }}
            >
              <Row justify={"center"}>
                <Typography.Title
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                  }}
                >
                  PHIẾU TẠM ỨNG
                </Typography.Title>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col>
                  <Descriptions
                    column={{
                      xs: 1,
                      sm: 1,
                      md: 1,
                      xl: 1,
                      lg: 1,
                      xxl: 1,
                    }}
                  >
                    <Descriptions.Item
                      label="Số"
                      labelStyle={{ width: "50px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinIn?.so}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Ngày ứng"
                      labelStyle={{ width: "100px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinIn?.ngayUng
                        ? moment(thongTinIn?.ngayUng).format(
                            FORMAT_TIME.dayFull
                          )
                        : ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Ngày in"
                      labelStyle={{ width: "100px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {moment().format(FORMAT_TIME.dayFull)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Mã phiếu khám"
                      labelStyle={{ width: "120px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinIn?.maPhieuKham}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Mã bệnh nhân"
                      labelStyle={{ width: "120px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinIn?.maBenhNhan}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Tên"
                      labelStyle={{ width: "64px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinIn?.hoTen}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Giới tính"
                      labelStyle={{ width: "100px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {gioiTinhOptions.find(
                        (it) => it.value === thongTinIn?.gioiTinh
                      )?.label || ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Tuổi"
                      labelStyle={{ width: "100px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinIn?.ngaySinh
                        ? birthday2Age(thongTinIn.ngaySinh, true)
                        : null}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Số tiền"
                      labelStyle={{ width: "100px", color: "#000000" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {formatToCurrencyType(thongTinIn?.soTienThu)}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>
              <Row justify={"center"}>
                <Col>
                  <Row>
                    <Row justify={"center"}>
                      <Typography.Text strong>Người nộp tiền</Typography.Text>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Text type="secondary">
                        (Ký và ghi rõ họ tên)
                      </Typography.Text>
                    </Row>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
      <Row justify={"end"} style={{ padding: "12px", gap: "4px" }}>
        <Space direction="horizontal">
          <Button danger type="primary" onClick={handleCancel}>
            HỦY
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  IN
                </Button>
              );
            }}
            content={() => printRef.current}
            onAfterPrint={handleCancel}
            bodyClass="print-tam-ung"
          />
        </Space>
      </Row>
    </Modal>
    // </Row>
  );
};

export default ModalPrint;
